import { Injectable } from '@angular/core';
import { AutomationStepsCountsModel } from './automation-steps-counts-model';

@Injectable({
  providedIn: 'root'
})

export class AutomationStepsCountsModelAdapter {

  adapt(item: any): AutomationStepsCountsModel {
    return new AutomationStepsCountsModel(item);
  }
  
  createEmpty(){
    return new AutomationStepsCountsModel({
      DueEmails: 0,
      SentEmails: 0,
      DueSMSs: 0,
      SentSMSs: 0
    });
  }
}